import React from "react";
import ProductSpread from "../ProductSpread/ProductSpread";
import all_products from "../Assets/all_stickers";
import prints from "../Assets/all_prints";

const NewProducts = () => {
  const new_products = [...all_products, ...prints].filter((item) => item.new_product);

  return (
    <div>
      <ProductSpread title="new stuff!" products={new_products} />
    </div>
  );
};

export default NewProducts;
